<template>
    <div class='sticky-container'>
        <slot />

        <div 
            v-if="url !== null" 
            class="sticky-area"
            :class="isShown && 'hide'"
        >
            <a :href="url" class="button green flex-grow h-[50px]" target="_blank">Book Now</a>
        </div>
    </div>
</template>


<script>
import { useIntersectionObserver } from '@vueuse/core'

export default {
    props: {
        url: String,
    },

    data: () => ({
        stoppers: null,
        isShown: false,
    }),

    mounted() {
        console.log(this.url)
        this.stoppers = document.querySelector("#hide-sticky-area")
        const { stop } = useIntersectionObserver(
          this.stoppers,
          ([{ isIntersecting, boundingClientRect }], _) => {
            if (isIntersecting || boundingClientRect.top > 0) {
                this.isShown = isIntersecting
            }
          },
        )
    },  

}
</script>

<style lang="scss" scoped>
.sticky-container {
    display: block;
    overflow: visible !important;
}

.hide {
    // display: none !important;
    bottom: -100px !important;
    transition: all 0.1s ease-out;
}

.sticky-area {
    display: flex;
    
    // position: -webkit-sticky;
    position: fixed;
    bottom: 0;
    justify-content: center;
    align-items: center;
    height: 96px;
    padding: 0 20px;
    width: 100%;
    background-color: #313E52;
    z-index: 98;
    transition: all 0.1s ease-in;

    @media (min-width: 640px) {
        display: none;
    }
}

</style>